import React from "react";
import { useEffect } from "react";
import "aos/dist/aos.css"; // Import the AOS styles
import AOS from "aos";

export default function About() {
  useEffect(() => {
    AOS.init(); // Initialize AOS
    AOS.refresh(); // Refresh AOS to detect new elements

    return () => {
      AOS.refreshHard(); // Cleanup AOS on component unmount
    };
  }, []);

  return (
    <>
      <div
        className=" vs:py-20 md:px-20 min-h-screen h-fit md:py-10 dark:bg-[#1e386b] dark:text-white"
        id="ABOUT"
      >
        <div className="flex justify-center">
          <h2 className="text-gray-800 font-Ubuntu text-4xl font-semibold pb-5 dark:text-white">
            All{" "}
            <span className="text-common-red border-b-4 border-common-red">
              About
            </span>{" "}
            Me
          </h2>
        </div>

        <div className="lg:flex justify-center font-space mt-10 sm:grid sm:grid-cols-1">
          <div
            data-aos="zoom-in-up"
            className="flex justify-center w-3/4 md:w-1/2 m-auto"
          >
            <img
              src={"/Images/hacker-1.jpg"}
              alt="about"
              width={"420px"}
              className="shadow-[#dc143c_20px_20px_3px_5px] dark:border-l-4 dark:border-t-4 dark:border-gray-300"
            />
          </div>
          <div
            className=" vs:my-5 lg:w-1/3 vs:w-3/4 vs:m-auto ml-5 text-lg text-gray-900 dark:text-white"
            data-aos="zoom-in-up"
          >
            <ul>
              <li className="list-disc pb-4 vs:mt-10 md:mt-0">
                Hello! My name is Mahin Malek & I enjoy creating things that
                live on the internet. I'm a passionate Developer, with strong
                administrative & communication skills, good attention to detail
                & the ability to write efficient code.
              </li>
              <li className="list-disc pb-4">
                Driven Full Stack Web Developer adept at collaborating with
                cross-functional teams to translate project requirements into
                scalable web applications.
              </li>
              <li className="list-disc pb-4">
                Proficient in JavaScript and experienced in MERN stack
                development (MongoDB, Express.js, React.js, Node.js). Skilled in
                RESTful API design, frontend technologies (HTML, CSS), and
                database systems (MongoDB).
              </li>
              {/* 
              <li className="list-disc pb-4">
                Whether enhancing an existing website or creating something new,
                you can rely on my dedication to delivering high-quality web
                experiences.
              </li> */}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
